// src/scenes/animalincident/index.jsx
import React from 'react';
import { Box } from '@mui/material';
import IncidentInformation from '../../components/forms/IncidentInformation';
import ReportingEntityInformation from '../../components/forms/ReportingEntityInformation';
import HumanVictimInformation from '../../components/forms/HumanVictimInformation';
import OffendingAnimalInformation from '../../components/forms/OffendingAnimalInformation';
import AnimalVictimInformation from '../../components/forms/AnimalVictimInformation';
import SignatureSection from '../../components/forms/SignatureSection';

export default function AnimalIncidentForm() {
    const handleSubmit = (e) => {
        e.preventDefault();
        // TODO: validation & submission logic
    };

    return (
        <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{
                width: '100%',                       // full width
                minHeight: '100vh',                  // at least full viewport height
                boxSizing: 'border-box',
                p: { xs: 2, sm: 4, md: 6 },          // responsive padding: 16px → 24px → 48px
                display: 'flex',
                flexDirection: 'column',
                gap: { xs: 2, sm: 4 },               // smaller gaps on mobile
                backgroundColor: 'background.default'
            }}
        >
            <IncidentInformation />
            <ReportingEntityInformation />
            <HumanVictimInformation />
            <OffendingAnimalInformation />
            <AnimalVictimInformation />
            <SignatureSection />
        </Box>
    );
}
